export {
  DEFAULT_LOCALE_TAG,
  LANGUAGE_OPTIONS,
  type LocaleEnum,
  type LocaleOption,
  type LocaleTag,
  LOCALE_TAG_LABELS,
  SUPPORTED_LOCALE_TAGS,
  isSupportedTag,
  localeEnumToTag,
  tagToLocaleEnum,
} from '@workspace/locales';

export const LOCALE_STORAGE_KEY = 'lucio_locale';
